import React from 'react';
import GenericNomenclatureList from './GenericNomenclatureList';
import { useDocumentationFieldTypeMutations } from '../../../hooks/useNomenclatures';

const DocumentationFieldTypeList = ({ items, onUpdate }) => {
  const mutations = useDocumentationFieldTypeMutations();

  const fields = [
    { name: 'category', label: 'Category', type: 'text', placeholder: 'e.g., Input' }
  ];

  return (
    <GenericNomenclatureList
      items={items}
      type="documentation-field-types"
      title="Documentation Field Types"
      fields={fields}
      mutations={mutations}
      onUpdate={onUpdate}
    />
  );
};

export default DocumentationFieldTypeList;



